import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import preloadSpaceBlogCountQuery, {
	type preloadSpaceBlogCountQuery$data,
	type preloadSpaceBlogCountQuery$variables,
} from './__generated__/preloadSpaceBlogCountQuery.graphql.ts';

export async function preloadSpaceBlogCount(spaceKey: string): Promise<{
	data: preloadSpaceBlogCountQuery$data | null;
	hasErrors: boolean;
}> {
	return query<preloadSpaceBlogCountQuery$data, preloadSpaceBlogCountQuery$variables>({
		query: preloadSpaceBlogCountQuery,
		variables: { spaceKey },
	});
}
